import { render, staticRenderFns } from "./editproduct.vue?vue&type=template&id=4d3c38c5&"
import script from "./editproduct.vue?vue&type=script&lang=js&"
export * from "./editproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports